import makeStyles from '@mui/styles/makeStyles';
import { CircularProgress, styled } from "@mui/material";

export const LoadingStyled = styled(CircularProgress)(() => ({
  color: "#475467",
}));

const styles = makeStyles(() => ({
  subGrid: {
    margin: "-6px -17px -6px -17px",
    padding: "0px",
    position: "relative",
    "& > div > div > div > table > tbody > tr": {
      backgroundColor: "#fff !important",
      "&:not(:last-child)": {
        borderBottom: "1px solid rgba(237, 245, 251, 1) !important",
      },
    },
    "& .tableContainerX": {
      borderRadius: "0px",
      position: "relative",
      "&::before": {
        content: "''",
        position: "absolute",
        left: 0,
        right: 0,
        width: "100%",
        height: "100%",
        boxShadow: "0px 0px 6px 2px rgba(70, 88, 105, 0.15) inset !important",
        zIndex: "2",
        pointerEvents: "none",
      },
    },
    "& table thead": {
      backgroundColor: "rgba(237, 245, 251, 1) !important",
    },
    "& table thead tr": {
      backgroundColor: "rgba(237, 245, 251, 1) !important",
    },
    "& table thead tr th:first-child": {
      paddingLeft: "15px !important",
    },
    "& table .tr-header th:first-child,th:last-child": {
      textAlign: "start !important",
      paddingLeft: "5px",
    },
    "& table tbody tr td:first-child": {
      paddingLeft: "15px !important",
    },
    "& table tbody tr td:last-child": {
      width: "5%",
    },
    "& .MuiTableContainer-root": {
      overflowX: "hidden !important",
    },
  },
  sku: { width: "10%" },
  poNumber: { width: "10%" },
  description: { width: "15%" },
  color: { width: "5%" },
  cbm: { width: "5%" },
  originCriterion: { width: "10%" },
  hscode: { width: "15%" },
  weight: { width: "5%" },
  size: { width: "5%" },
  quantity: { width: "5%" },
  status: { width: "5%" },
  missingDetailIcon: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    "& svg": {
      width: "16px",
      height: "16px",
    },
  },
  printLabelButton: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "12px",
    whiteSpace: "nowrap",
  },
  badge: {
    padding: "8px 12px",
    height: "32px",
    borderRadius: "100px",
    whiteSpace: "nowrap",
    width: "fit-content",
  },
}));

export default styles;
